export function Ico24ArrowRight({ ...props }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.22656 18.7939L15.5153 12.234C15.6533 12.1099 15.6533 11.8936 15.5153 11.7695L8.22656 5.20957"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
